module.exports = __webpack_public_path__ + "static/22-73020350023ce7e7dced06cb0c604d31.jpg";